<template>
  <div v-if="visible" class="release-banner" role="status">
    <div class="release-banner__inner">
      <v-icon class="release-banner__icon">campaign</v-icon>
      <div class="release-banner__copy">
        <p class="release-banner__headline">
          Exciting news! ParentFinder 2.0 is almost here and will be available soon.
        </p>
      </div>
    </div>
    <button
      type="button"
      class="release-banner__close"
      aria-label="Dismiss announcement"
      @click.stop.prevent="dismiss"
    >
      <v-icon>close</v-icon>
    </button>
  </div>
</template>

<script>
const STORAGE_KEY = 'PF.ReleaseBanner.NewParentFinder.2026-08-07.v2';

export default {
  name: 'ReleaseBanner',
  data () {
    return {
      visible: !window.localStorage.getItem(STORAGE_KEY)
    };
  },
  methods: {
    dismiss () {
      try {
        window.localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) { /* ignore quota / private mode */ }
      this.visible = false;
      this.$emit('dismissed');
    }
  }
};
</script>

<style scoped>
.release-banner {
  background: #4F46E5;
  color: #fff;
  border-bottom: none;
  position: relative;
  z-index: 11;
  pointer-events: auto;
}

.release-banner__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  max-width: 1100px;
  margin: 0 auto;
  padding: 14px 52px 14px 20px;
  text-align: left;
  pointer-events: none;
}

.release-banner__icon {
  flex-shrink: 0;
  font-size: 28px !important;
  color: #fff !important;
  opacity: 0.95;
}

.release-banner__copy {
  min-width: 0;
}

.release-banner__headline {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.35;
  letter-spacing: 0.01em;
  color: #fff;
}

.release-banner__close {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  cursor: pointer;
  color: #fff;
  z-index: 12;
  pointer-events: auto;
}

.release-banner__close >>> .v-icon {
  color: #fff !important;
  font-size: 20px !important;
}

.release-banner__close:hover {
  background: rgba(255, 255, 255, 0.3);
}

@media (max-width: 600px) {
  .release-banner__inner {
    align-items: flex-start;
    padding: 12px 44px 12px 14px;
    gap: 10px;
  }

  .release-banner__icon {
    font-size: 22px !important;
    margin-top: 2px;
  }

  .release-banner__headline {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReleaseBanner.vue